import ChatSupport from '../../components/ChatSupport';
import typing from '../../assets/lotties/typing.json';
import Lottie from 'lottie-react';
import { EProblemFeedback, ILiteralFeedback, IProblemEvent } from '../../models/Problems.interfaces';
import i18n from 'i18next';

const lottie = () => {
    return <Lottie animationData={typing} style={{ height: 18, width: 34 }} />;
};
export const LoaderMessage = <ChatSupport text={lottie()}></ChatSupport>;

export const orderArrayDates = (dates: any, keyDate: string = 'date') =>
    dates.sort((a: { [key: string]: string }, b: { [key: string]: string }) => {
        return +new Date(a[keyDate]) - +new Date(b[keyDate]);
    });

export const handleOrderByTimeEvents = (data: IProblemEvent[]) => orderArrayDates(data, 'createdAt');

export const literalsFeedback = (type: EProblemFeedback) => {
    const literals: { [key: string]: ILiteralFeedback } = {
        service: {
            state: 'ERROR',
            title: i18n.t('supportErrorFeedbackFailedTitle'),
            subtitle: i18n.t('supportErrorFeedbackFailedDescription'),
        },
        incidence: {
            state: 'ERROR',
            title: i18n.t('supportErrorFeedbackErrorOccurredTitle'),
            subtitle: i18n.t('supportErrorFeedbackErrorOccurredDescription'),
        },
        pending: {
            state: 'INFO',
            title: i18n.t('supportInfoFeedbackPendingIncidentTitle'),
            subtitle: `${i18n.t('supportInfoFeedbackPendingIncidentDescription')}\n\nNº: ${new URLSearchParams(
                window.location.search,
            ).get('code')}`,
        },
        technician_assignment_pending: {
            state: 'INFO',
            title: i18n.t('supportInfoFeedbackReviewIncidenTitle'),
            subtitle: `${i18n.t('supportInfoFeedbackReviewTechnicalIncidentDescription')}\n\nNº: ${new URLSearchParams(
                window.location.search,
            ).get('code')}`,
        },
        shipment_pending: {
            state: 'INFO',
            title: i18n.t('supportInfoFeedbackInProgressIncidentTitle'),
            subtitle: i18n.t('supportInfoFeedbackShipmentPendingIncidentDescription'),
        },
        exist_issue: {
            state: 'INFO',
            title: i18n.t('supportInfoFeedbackExistsIncidentTitle'),
            subtitle: i18n.t('supportInfoFeedbackExistsIncidentDescription'),
        },
        diagnosis: {
            state: 'ERROR',
            title: i18n.t('supportErrorFeedbackFailedTitle'),
            subtitle: i18n.t('supportErrorDiagnosisFeedbackFailedDescription'),
        },
        error_masive: {
            state: 'ERROR',
            title: i18n.t('supportErrorMasiveFeedbackFailedTitle'),
            subtitle: i18n.t('supportErrorMasiveFeedbackFailedDescription'),
        },
        error_connection: {
            state: 'ERROR',
            title: i18n.t('supportErrorFeedbackFailedTitle'),
            subtitle: i18n.t('supportErrorFeedbackFailedConnectionDescription'),
        },
        revision_not_conformity: {
            state: 'INFO',
            title: i18n.t('supportInfoFeedbackReviewIncidenTitle'),
            subtitle: `${i18n.t('supportInfoFeedbackReviewIncidentDescription')}\n\nNº: ${new URLSearchParams(
                window.location.search,
            ).get('code')}`,
        },
        revision_technical: {
            state: 'INFO',
            title: i18n.t('supportInfoFeedbackReviewIncidenTitle'),
            subtitle: `${i18n.t('supportInfoFeedbackReviewTechnicalIncidentDescription')}\n\nNº: ${new URLSearchParams(
                window.location.search,
            ).get('code')}`,
        },
        logistic_shipping: {
            state: 'INFO',
            title: i18n.t('supportInfoFeedbackInProgressIncidentTitle'),
            subtitle: `${i18n.t('supportInfoFeedbackReviewTechnicalIncidentDescription')}\n\nNº: ${new URLSearchParams(
                window.location.search,
            ).get('code')}`,
        },
        success: {
            state: 'SUCCESS',
            title: i18n.t('supportSuccessFeedbackTitle'),
            subtitle: `${i18n.t('supportSuccessFeedbackDescription')}\n\nNº: ${new URLSearchParams(
                window.location.search,
            ).get('code')}`,
        },
    };
    return literals[type];
};
